import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, NgZone } from '@angular/core';

import { PotreeCesiumViewerService } from './potree-cesium-viewer.service';
import { MapService } from '../../services/map/map.service';
import { AssetLoaderService } from 'src/app/services/asset-loader/asset-loader.service';


declare var Cesium;
declare var Potree;
declare var THREE;
declare var window;
declare var $;
declare var proj4;

@Component({
	selector: 'app-potree-cesium-viewer',
	templateUrl: './potree-cesium-viewer.component.html',
	styleUrls: ['./potree-cesium-viewer.component.sass']
})
export class PotreeCesiumViewerComponent implements OnInit, OnDestroy {

	@ViewChild("cesiumContainer") cesiumContainer:ElementRef;

	cesiumViewer:Cesium.Viewer;
	potreeViewer:any;

	activePointClouds:typeof Potree.PointCloudOcTree[] = [];
	shouldKillPreviousPointClouds:boolean = true;
	doOrbit:boolean = true;
	USE_PROXY:boolean = false;

	constructor (
		private ngZone: NgZone,
		public potreeCesiumViewerService: PotreeCesiumViewerService,
		private mapService: MapService,
		private assetLoader: AssetLoaderService
	) { }

	ngOnInit () {
	}

	ngAfterViewInit () {
		const loadScripts = async () => {
			await this.assetLoader.loadScript('https://unpkg.com/three@0.106.2/build/three.min.js')
      		await this.assetLoader.loadScript('https://unpkg.com/three@0.106.2/examples/js/loaders/GLTFLoader.js')
			await this.assetLoader.loadScript('assets/libs/three.js/extra/lines.js')
			await this.assetLoader.loadScript('assets/libs/potree/potree.js')
			
			this.initCesium();
			this.initPotreeViewer();
    	}
    	loadScripts()
	}

	initCesium () :void {
		var suntoryToken = 'pk.eyJ1IjoiaW50dWl0aXZlYmFkZ2VyIiwiYSI6ImNrOXZpeXZiNzBkN3Iza29saHhjOWo2OGwifQ.QOMbmOzi8OhYw6NYyDqBRQ';
		var suntoryMapbox = new Cesium.UrlTemplateImageryProvider({
			url: `https://api.mapbox.com/styles/v1/intuitivebadger/ckfdel5j40z8p19o6o0xu05sd/tiles/512/{z}/{x}/{y}?access_token=${suntoryToken}`
		});

		var satelliteMapbox = new Cesium.UrlTemplateImageryProvider({
			url: `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/512/{z}/{x}/{y}?access_token=${suntoryToken}`
		});

		Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMzE4MDQ5MS01ZGQ5LTQ4Y2YtYjM2NC0xN2M3ZjVkNDJhYzEiLCJpZCI6MzM3MTgsImlhdCI6MTYwMzI5MDEyNH0.-DXOwYMj_Uh_GEvB1tXNRShH7AmcK3rouQAEKZi6POQ';

		const maptilerCloudKey = "4NPkGm68tXrL0Zs3bC9s"; // thaqif's premium key

		this.cesiumViewer = new Cesium.Viewer(this.cesiumContainer.nativeElement, {
			//useDefaultRenderLoop: false,
			animation: false,
			baseLayerPicker : false,
			fullscreenButton: false, 
			geocoder: false,
			homeButton: false,
			infoBox: false,
			sceneModePicker: true,
			selectionIndicator: false,
			timeline: false,
			navigationHelpButton: false,
			//imageryProvider : Cesium.createOpenStreetMapImageryProvider({url : 'https://a.tile.openstreetmap.org/'}),
			//imageryProvider: satelliteMapbox,
			terrainShadows: Cesium.ShadowMode.DISABLED,
			sceneMode: Cesium.SceneMode.SCENE3D,
		});

		window.cesiumViewer = this.cesiumViewer;

		this.cesiumViewer.terrainProvider = new Cesium.CesiumTerrainProvider({
			url: 'https://api.maptiler.com/tiles/terrain-quantized-mesh/?key=' + maptilerCloudKey
		});

		this.cesiumViewer.scene.globe.northPoleColor = new Cesium.Cartesian3(0.0 / 255.0, 0.0 / 255.0, 0.0 / 255.0);
		this.cesiumViewer.scene.globe.southPoleColor = new Cesium.Cartesian3(0.0 / 255.0, 0.0 / 255.0, 0.0 / 255.0);

		let cp = new Cesium.Cartesian3(4303414.154026048, 552161.235598733, 4660771.704035539);
		this.cesiumViewer.camera.setView({
			destination : cp,
			orientation: {
				heading : 10, 
				pitch : -Cesium.Math.PI_OVER_TWO * 0.5, 
				roll : 0.0 
			}
		});
	}

	// bkp german potree link
	// https://aerodyne-karin.s3.eu-central-1.amazonaws.com/Wilhelm-Busch-Schule%20Mannheim/Processed/Potree/WilhelmBuschSchuleMannheim/index.html

	initPotreeViewer () :void {
		this.potreeViewer = new Potree.Viewer(document.getElementById("potree_render_area"), {
			//useDefaultRenderLoop: false
		});

		this.potreeViewer.setEDLEnabled(true);
		this.potreeViewer.setFOV(60);
		//this.potreeViewer.setPointBudget(4*1000*1000);
		this.potreeViewer.setPointBudget(5 * 1000 * 1000);
		this.potreeViewer.setMinNodeSize(50);
		this.potreeViewer.loadSettingsFromURL();
		this.potreeViewer.setBackground(null);
		this.potreeViewer.useHQ = true;

		this.potreeViewer.loadGUI(() => {
			this.potreeViewer.setLanguage('en');
			$("#menu_appearance").next().show();
			$("#menu_tools").next().show();
			$("#menu_scene").next().show();
			//potreeViewer.toggleSidebar();
			//potreeViewer.toggleMap();
		});

		window.potreeViewer = this.potreeViewer;

		this.potreeCesiumViewerService.viewer = this.potreeViewer;
		this.potreeCesiumViewerService.controller = this;

		this.potreeCesiumViewerService.viewerIsActive$.subscribe(isActive => {
			if (isActive) {
				this.renderIsPaused = false;
			} else {
				this.renderIsPaused = true;
			}
			
		})

	}

	loadPointCloud (rawUrl:string) :Promise<PotreeCloudJsData> {

		return new Promise<PotreeCloudJsData>((resolve, reject) => {
			const url = rawUrl.replace(/(?=\w+\.\w{3,4}$).+/, 'pointclouds/index/cloud.js')
			if (url.indexOf("cloud.js") < 0) { // wrong url format

				
				reject(null);

			} else {

				const proxy = "https://proxy.aerodyne.dev/";
				const pcUrl = this.USE_PROXY ? proxy + url : url;
				
				Potree.loadPointCloud(pcUrl, "Point Clouds", (e) => {

					let scene = this.potreeViewer.scene;

					if (!e.pointcloud) { // failed to load the pointclouds
						reject(null);
					} else {
						if (this.shouldKillPreviousPointClouds) {
							this.unloadAllPointClouds();
						}

						scene.addPointCloud(e.pointcloud);
						this.activePointClouds.push(e.pointcloud);
					}

					const cloudJsData = e.jsonData;

					const px = cloudJsData.tightBoundingBox.lx;
					const py = cloudJsData.tightBoundingBox.ly;
					const pz = cloudJsData.tightBoundingBox.lz;
					//const pz = -5;

					const lx = e.pointcloud.boundingSphere.center.x;
					const ly = e.pointcloud.boundingSphere.center.y;
					const lz = e.pointcloud.boundingSphere.center.z;

					e.pointcloud.position.set(px, py, pz);
					e.pointcloud.scale.set(1, 1, 1);
					this.activePointClouds.push(e.pointcloud);

					
					

					this.mapService.activePotreeJSONData$.next(e.jsonData);

					let material = e.pointcloud.material;
					material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
					material.size = 0.7;
					material.elevationRange = [0, 70];
					material.weightRGB = 1.0;
					material.weightElevation = 1.0;

					scene.view.position.set(lx, ly, lz);
					this.potreeViewer.setView("AUTO-ORBIT");

					let pointcloudProjection;
					if (e.pointcloud.projection) {
						pointcloudProjection = e.pointcloud.projection;
					} else {
						pointcloudProjection = "+proj=utm +zone=54N +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
					}

					let mapProjection = proj4.defs("WGS84");

					window.toMap = proj4(pointcloudProjection, mapProjection);
					window.toScene = proj4(mapProjection, pointcloudProjection);

					if (window.toMap) {
						let bb = this.potreeViewer.getBoundingBox();

						let minWGS84 = proj4(pointcloudProjection, mapProjection, bb.min.toArray());
						let maxWGS84 = proj4(pointcloudProjection, mapProjection, bb.max.toArray());
					}

					this.ngZone.runOutsideAngular(() => this.onTick());

					resolve(cloudJsData as PotreeCloudJsData);
				});
			}
		});
	}

	unloadAllPointClouds () {
		this.potreeViewer.scene.removeAllPointCloud();
		this.activePointClouds.length = 0;
	}

	rafId = 0;
	renderIsPaused:boolean = false;

	onTick () {

		this.rafId = requestAnimationFrame(this.onTick.bind(this));

		this.potreeViewer.update(this.potreeViewer.clock.getDelta(), this.rafId);
		this.potreeViewer.render();

		if (window.toMap !== undefined) {
			let camera = this.potreeViewer.scene.getActiveCamera();
			if(camera instanceof THREE.PerspectiveCamera){
				let pPos		= new THREE.Vector3(0, 0, 0).applyMatrix4(camera.matrixWorld);
				let pRight  = new THREE.Vector3(600, 0, 0).applyMatrix4(camera.matrixWorld);
				let pUp		 = new THREE.Vector3(0, 600, 0).applyMatrix4(camera.matrixWorld);
				let pTarget = this.potreeViewer.scene.view.getPivot();
				let toCes = (pos) => {
					let xy = [pos.x, pos.y];
					let height = pos.z;
					let deg = window.toMap.forward(xy);
					let cPos = Cesium.Cartesian3.fromDegrees(...deg, height);
					return cPos;
				};
				let cPos = toCes(pPos);
				let cUpTarget = toCes(pUp);
				let cTarget = toCes(pTarget);
				let cDir = Cesium.Cartesian3.subtract(cTarget, cPos, new Cesium.Cartesian3());
				let cUp = Cesium.Cartesian3.subtract(cUpTarget, cPos, new Cesium.Cartesian3());
				cDir = Cesium.Cartesian3.normalize(cDir, new Cesium.Cartesian3());
				cUp = Cesium.Cartesian3.normalize(cUp, new Cesium.Cartesian3());
				this.cesiumViewer.camera.setView({
					destination : cPos,
					orientation : {
						direction : cDir,
						up : cUp
					}
				});
				let aspect = this.potreeViewer.scene.getActiveCamera().aspect;
				let frustum = this.cesiumViewer.camera.frustum as Cesium.PerspectiveFrustum;
				if (aspect < 1) {
					let fovy = Math.PI * (this.potreeViewer.scene.getActiveCamera().fov / 180);
					frustum.fov = fovy;
				} else {
					let fovy = Math.PI * (this.potreeViewer.scene.getActiveCamera().fov / 180);
					let fovx = Math.atan(Math.tan(0.5 * fovy) * aspect) * 2;
					frustum.fov = fovx;
				}
				this.cesiumViewer.render();
			} else {
				
			}
		}

		if (this.renderIsPaused) { return; } // pause on tick when viewer is not active
	}

	ngOnDestroy () :void {
		cancelAnimationFrame(this.rafId);
		this.potreeCesiumViewerService.viewerIsActive$.unsubscribe();
		this.potreeCesiumViewerService.unloadAllPointClouds()
	}
}

export interface PotreeCloudJsData {
	version:string,
	octreeDir:string,
	projection?: string,
	points: number,
	boundingBox: {
		lx: number,
		ly: number,
		lz: number,
		ux: number,
		uy: number,
		uz: number
	},
	tightBoundingBox: {
		lx: number,
		ly: number,
		lz: number,
		ux: number,
		uy: number,
		uz: number
	},
	pointAttributes: string[],
	spacing: number,
	scale: number,
	hierarchyStepSize: number
}

export enum PotreeCesiumToolType {
	MeasureHeightTool = "measureHeightTool",
	MeasureDistanceTool = "measureDistanceTool",
	MeasurePointTool = "measurePointTool",
	MeasureAreaTool = "measureAreaTool",
	MeasureCircleTool = "measureCircleTool",
	MeasureAzimuthTool = "measureAzimuthTool",
	MeasureAngleTool = "measureAngleTool",
	None = "none"
}